export default {
  inserted: function (el, binding) {
    const value = binding.value;
    if (value == null || value === true) {
      el.focus();
    }
  },
}
